import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=29b9961a&scoped=true"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=29b9961a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b9961a",
  null
  
)

export default component.exports